<mat-dialog-content>
  <section class="w3l-hero-headers-11 p-sticky-md">
    <div class="top-header">
      <div class="d-grid grid-columns-top-3">
        <div class="accounts">
          <ul>
            <li></li>
            <li></li>
          </ul>
        </div>
        <div class="search">
          <form action="search-results.html" method="get">
            <input id="search" name="search" type="text" [(ngModel)]="catCode" (keyup) = "retriveDoctorsLookup()"
              placeholder="Category Code">
            <label>                      </label>
            <input id="search" name="search" type="text" [(ngModel)]="catName" (keyup)="retriveDoctorsLookup()"
              placeholder="Category Name">

          </form>
        </div>
      </div>
    </div>
  </section>

  <table>
    <thead>
      <tr>
        <th style="width: 30%;">Doctor Code</th>
        <th style="width: 100%;">Doctor Name</th>
        <th style="width: 20%;">Choose</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let Do of ContCategoryList; let i = index">
        <td data-column="Doctor ID">{{Do.catCode}}</td>
        <td data-column="Doctor Name">{{Do.catName}}</td>

        <td data-column="Choose"><button type="button" class="theme-button btn" id="select" name="select"
            (click)="SelectContCategory(Do)">Select</button>
        </td>
      </tr>

    </tbody>
  </table>
</mat-dialog-content>


